import { SettingsPageHeaderRoot } from "./SettingsPageHeaderRoot/SettingsPageHeaderRoot";
import { SettingsPageHeaderTitle } from "./SettingsPageHeaderTitle/SettingsPageHeaderTitle";
import { SettingsPageHeaderCaption } from "./SettingsPageHeaderCaption/SettingsPageHeaderCaption";
import { SettingsPageHeaderOperatingUnitSelection } from "./SettingsPageHeaderOperatingUnitSelection/SettingsPageHeaderOperatingUnitSelection";

export const Root = SettingsPageHeaderRoot;
export const Title = SettingsPageHeaderTitle;
export const Caption = SettingsPageHeaderCaption;
export const OperatingUnitSelection = SettingsPageHeaderOperatingUnitSelection;
